import React from "react";
import CountUp from "react-countup";
import { Dog, PackageCheck, Star } from "lucide-react";

import { PetsReportController } from "../../../../services/controllers/reports";
import { usePetsReport } from "../../../../store/reports/usePetsReport";

import { Summary } from "../../../../components/ui/Summary";

export function PetsReportSummary() {
  const CPetsReport = PetsReportController();

  const summary = usePetsReport((st) => st.data.summary);
  const filter = usePetsReport((st) => st.data.filter);
  const loading = usePetsReport((st) => st.data.isLoading);

  const filtered = filter.hasPackage !== "*" || filter.isSubscriber !== "*";

  const clearAll = () => {
    CPetsReport.setFilter({ hasPackage: "*", isSubscriber: "*" });
    CPetsReport.filterPets();
  };

  return (
    <Summary.Root>
      <Summary.Box active={!filtered} onClick={filtered ? clearAll : undefined}>
        <Summary.Icon icon={Dog} />
        <Summary.TextContent>
          <Summary.Title size="big">
            <CountUp end={loading ? 0 : summary.petTotal} separator="." preserveValue useEasing />
          </Summary.Title>
          <Summary.Text>Total de pets</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>

      <Summary.Box
        active={filter.hasPackage === "true"}
        onClick={() => CPetsReport.toggleFilter("hasPackage", "true")}
      >
        <Summary.Icon icon={PackageCheck} />
        <Summary.TextContent>
          <Summary.Title size="big">
            <CountUp end={loading ? 0 : summary.withPackage} separator="." preserveValue useEasing />
          </Summary.Title>
          <Summary.Text>Tem pacote</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>

      <Summary.Box
        active={filter.isSubscriber === "true"}
        onClick={() => CPetsReport.toggleFilter("isSubscriber", "true")}
      >
        <Summary.Icon icon={Star} />
        <Summary.TextContent>
          <Summary.Title size="big">
            <CountUp end={loading ? 0 : summary.subscribers} separator="." preserveValue useEasing />
          </Summary.Title>
          <Summary.Text>É assinante</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>
    </Summary.Root>
  );
}
